<template>
    <v-chip
      class="pa-3"
      outlined
      small
    >
      <v-icon
        :disabled="number === min"
        @click="minus"
        :color="number > min ? 'primary' : '#C4C4C4'"
        left
      >
        remove_circle_outline
      </v-icon>
      <span class="font-weight-bold">
        {{ number }}
      </span>
      <v-icon
        :disabled="number === max"
        @click="plus"
        :color="number < max ? 'primary' : '#C4C4C4'"
        right
      >
        add_circle_outline
      </v-icon>
    </v-chip>
  </template>
  
  <script>
  export default {
    name: 'NumberSelector',
    props: {
      id: {
        type: Number,
        required: true
      },
      dataValue: {
        type: Number,
        required: true,
      },
      min: {
        type: Number,
        required: false,
        default: 0
      },
      max: {
        type: Number,
        required: false,
        default: 5
      }
    },
    created() {
      this.number = this.dataValue
    },
    data () {
      return {
        number: 0
      }
    },
    methods: {
      update () {
        this.$emit('update', {id: this.id, value: this.number})
      },
      minus () {
        this.number -= 1
        this.update()
      },
      plus () {
        this.number += 1
        this.update()
      }
    }
  }
  </script>
  
  <style>
  
  </style>